import { IBidRequest, IPrebidAdapter } from '../../../typings/IPrebidAdapter'
import { IxDemand, HtSlots } from '../../../typings/IRoundel'
import CMP from '../../cmp/cmp'
import { Bidder } from '../../enums'
import WebModel from '../../models/WebModel'

enum PREBID_STATUS_CODES {
  GOOD = 1,
  NO_BID = 2
}

// Don't know what this really is; it's not part of the response.  IndexExchange uses 35.
const ROUNDEL_TTL = 35

export default class RoundelAdapter implements IPrebidAdapter {
  static roundelTargeting = {}
  code = 'roundel'

  constructor(model: WebModel, cmp: CMP, private _window: Window = window) {
    // nothing!
  }

  callBids(bidRequest: IBidRequest, addBidResponse, done): void {
    const htSlots: HtSlots = []

    bidRequest.bids.forEach((bid) => {
      // Roundel isn't bidding on content_#_btf, only on content_btf
      const baseAdUnitId = bid.adUnitCode.replace(/_[0-9]+|_refresh/g, '')

      // Add to array we're going to request
      htSlots.push({
        htSlotName: baseAdUnitId
      })
    })

    this._window.headertag.retrieveDemand(htSlots, (demand: IxDemand) => {
      for (const adUnitId in demand.slot) {
        const adUnitBids = demand.slot[adUnitId]

        // Set up Roundel bids to send to Prebid.
        adUnitBids.forEach((adunit) => {
          const bidObject = this._window.pbjs.createBid(
            PREBID_STATUS_CODES.GOOD
          )

          bidObject.bidderCode = Bidder.roundel
          bidObject.width = adunit.size[0]
          bidObject.height = adunit.size[1]
          bidObject.cpm = adunit.price / 100
          bidObject.currency = 'USD'
          bidObject.ad = adunit.adm
          bidObject.ttl = ROUNDEL_TTL

          addBidResponse(adUnitId, bidObject)
        })
      }

      // We're done
      done()
    })
  }
}
